import React from "react";
import { fetchJson } from "../../lib/Fetching";

// This functional react component displays sample information for a sample.
// It fetches the data from /laboratory/samples/:id/sample_information.json
// It is possible that this url returns a not authorized error, in which case
// the component will show nothing.

// Props:
// sampleId: the id of the sample to fetch sample information for
// type: a string indicating the type of sample information to fetch

export default function SampleInformation(props) {
  const { sampleId, type } = props;
  const [sampleInformation, setSampleInformation] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(
    () => {
      if (sampleId) {
        fetchJson(`/laboratory/samples/${sampleId}/information.json`, {
          type,
        })
          .then((json) => {
            setSampleInformation(json);
            setLoading(false);
          })
          .catch((error) => {
            setError(error);
            setLoading(false);
          });
      }
    },
    [sampleId, type]
  );

  if (loading) {
    return null;
  } else if (error) {
    return null;
  } else if (sampleInformation.error) {
    return null;
  } else if (sampleInformation && sampleInformation.information.length > 0) {
    return (
      <div>
        {sampleInformation.information.map((info) => (
          <div className="alert alert-warning">{info}</div>
        ))}
      </div>
    );
  } else {
    return null;
  }
}
